<template>

	<!-- TODO: This should be inside an "Account Container", just like the PROJECT/S setup -->
	<div class="container-fluid">
		<div class="row">
			<div class="col mb-4">

				<div class="card shadow-sm mb-4">
					<div class="card-header">
						<button class="btn btn-light" style="position: absolute; right: 0.5em; top: 0.5em;" @click.prevent="refreshAccount"><i class="fas fa-sync-alt"></i> Refresh</button>
						<h4 class="my-0 font-weight-normal">Account Settings</h4>
					</div>
					<div class="card-body">
						<form autocomplete="off">
							<div class="form-group">
								<label for="accountSettings_id">Account ID</label>
								<input disabled :value="accountSettings.$id" type="text" class="form-control" id="accountSettings_id" aria-describedby="accountSettings_idHelp">
							</div>
							<div class="form-group">
								<label for="accountSettings_email">Primary Email Address</label>
								<input v-model="accountSettingsEmail" type="email" class="form-control" id="accountSettings_email" aria-describedby="accountSettings_emailHelp" placeholder="Enter new email address">
								<small id="accountSettings_emailHelp" class="form-text text-muted">Primary email address for the account (e.g. "jsmith28@testmail.com")</small>
							</div>
							<div class="form-group">
								<label for="accountSettings_password">Password</label>
								<input v-model="accountSettings.$$password" type="password" class="form-control" id="accountSettings_password" aria-describedby="accountSettings_passwordHelp" placeholder="Enter new password" autocomplete="new-password">
								<small id="accountSettings_passwordHelp" class="form-text text-muted">New password for the account</small>
							</div>
							<div class="form-group">
								<label for="accountSettings_name">Full Name</label>
								<input v-model="accountSettings.name" type="text" class="form-control" id="accountSettings_name" aria-describedby="accountSettings_nameHelp" placeholder="Enter full name">
								<small id="accountSettings_nameHelp" class="form-text text-muted">Full name for the account (e.g. "Joe R. Smith")</small>
							</div>
							<div class="form-group">
								<label for="accountSettings_desc">Description</label>
								<textarea v-model="accountSettings.description" type="text" class="form-control" id="accountSettings_desc" aria-describedby="accountSettings_descHelp" placeholder="Enter description" rows="2"></textarea>
								<small id="accountSettings_descHelp" class="form-text text-muted">Descriptive details (e.g. "This is a testing account")</small>
							</div>
							<div class="form-check" v-if="currentSessionAccount.roles && currentSessionAccount.roles.admin === true">
								<input v-model="accountSettings.roles.admin" type="checkbox" class="form-check-input" id="accountSettings_admin">
								<label class="form-check-label" for="accountSettings_admin" aria-describedby="accountSettings_adminHelp">Administrator <small class="text-muted">(superuser access to this entire node)</small></label>
							</div>

							<div class="form-group">
								<button class="btn btn-success mt-4" @click.prevent="saveAccountSettings" ><i class="fas fa-save"></i> Save Account Settings</button>
								<button class="btn btn-secondary mt-4" @click.prevent="resetAccount"><i class="fas fa-sync-alt"></i> Reset Form</button>
								<button class="btn btn-danger float-right mt-4" @click.prevent="deleteThisAccount"><i class="fas fa-times"></i> Delete Account</button>
							</div>
							
						</form>
					</div>
				</div>

				<div class="card shadow-sm">
					<div class="card-header">
						<h4 class="my-0 font-weight-normal">Account Settings (JSON)</h4>
					</div>
					<div class="card-body">

						<div id="editor"></div>
						<button class="btn btn-success mt-4" @click.prevent="saveEditorAccount"><i class="fas fa-save"></i> Save Account</button>
						<button class="btn btn-secondary mt-4" @click.prevent="setEditorAccount( )"><i class="fas fa-sync-alt"></i> Reset Editor</button>
						
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>

import 'ace-builds';
import 'ace-builds/webpack-resolver';

import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import _ from 'lodash';

export default {
	name: "account-view",
	props: [ 'nodeId', 'accountId' ],
	data() {
		return {
			accountSettingsEmail : "",
			accountSettings : { roles : { } }
		};
	},
	watch:
	{
		accountSettings:
		{
			handler: function( newValue, oldValue ) { this.setEditorAccount( ); },
			deep : true
		},
		accountSettingsEmail: function( newValue, oldValue )
		{
			let primaryEmail = this.accountPrimaryEmail;
			if( newValue == "" )
			{
				if( !primaryEmail )
					this.accountSettings.email = { [primaryEmail] : { primary : true } };	// Reset the email.
				else
					this.accountSettings.email = { };
				return;
			}
			
			if( newValue == primaryEmail )	// Cannot be empty at this point.
				this.accountSettings.email = { };
			else
			{
				this.accountSettings.email = {
					[newValue] : { primary : true },
					[primaryEmail] : { $delete : true }
				}
			}
		},
	},
	computed:
	{
		accountPrimaryEmail( )
		{
			let originalAccount = this.getAccount( ) || { };
			if( !originalAccount.email )
				return null;

			for( let e in originalAccount.email )
				if( originalAccount.email[e].primary === true )
					return e;
			
			return null;	// No primary email found
		},
		currentSessionAccount: function( )
		{
			try {
				let sessionGuid = this.activeSession( this.nodeId );
				let [ sNode, sKey ] = sessionGuid.split( "/" );
				let session = this.session( sessionGuid );
				let account = this.account( sNode, session.account );
				if( account )
					return account;
			} catch( err ) { }
			return { };	// No session.
		},
		...mapGetters( "accounts", {
			accounts: "accounts",
			account: "account",
		}),
		...mapGetters( "authentication", {
			activeSession: "activeSession",
			session: "session"
		}),
	},
	methods:
	{
		async refreshAccount( )
		{
			// TODO: Start Loading
			await this.readAccount( { nodeId : this.nodeId, accountId : this.accountId, nocache : true } );	
			this.resetAccount( );
			// TODO: End Loading
		},
		async deleteThisAccount( )
		{
			if( !confirm( "Are you sure you want to delete this account?" ) )
				return;
			try {
				let result = await this.deleteAccount( { nodeId : this.nodeId, accountId : this.accountId } );
				if( !result )
					console.warn( "[Account] Account was not found at deletion! Redirecting to Accounts listing anyway." );
				this.$router.push( { name : 'accounts', params : { nodeId : this.nodeId } } );
			} catch( err ) {
				console.error( err );
				alert( "Account could not be deleted!\n"+ err.message );
			}
		},
		getAccount( )
		{
			let account = this.account( this.nodeId, this.accountId ) || { };
			if( account && !account.roles )
				account.roles = { };
			return account;
		},
		resetAccount( )
		{
			let accountSettings = _.cloneDeep( this.getAccount( ) );
			if( !accountSettings.roles )
				accountSettings.roles = { };
			this.accountSettings = accountSettings;
			this.accountSettingsEmail = this.accountPrimaryEmail;
		},
		setEditorAccount( account )
		{
			account = account || this.accountSettings;	//this.$store.state.accounts.lookup[this.nodeId][this.accountId];
			if( account && this.editor )
			{
				if( !account.$$password ) delete account.$$password;
				if( !account.name ) delete account.name;
				//if( !account. )

				let editorAccount = _.omit( account, [ '$created', '$modified', '$version', '$node', 'auth_hash' ] );
				this.editor.setValue( JSON.stringify( editorAccount, null, 2 ), -1 );
			}

		},
		async saveAccountSettings( )
		{
			let account = _.omit( this.accountSettings, [ '$created', '$modified', '$version', '$node', 'auth_hash' ] );;

			let id = this.getAccount( ).$id;

			try {
				let result = await this.updateAccount( { nodeId : this.nodeId, accountId : id, updates : account } );
				if( !id || null === result )
					throw new Error( "This account is no longer found in the repository!" );
				
				// TODO: close loading overlay

			} catch( err ) {

				// TODO: Switch loading overlay to ERROR overlay.

				console.warn( "Account save failed:", err );

				// TODO: Set this action, as the result of dismissing the ERROR OVERLAY
				this.$router.push( { name : 'accounts', params : { nodeId : this.nodeId } } );
			}
		},
		async saveEditorAccount( )
		{
			// TODO: Set loading overlay
			let account;

			try {
				account = JSON.parse( this.editor.getValue( ) );
			} catch( err ) {
				alert( "Could not save the object:\n"+ err.message );
				console.error( err );
				return;
			}

			let id = this.getAccount( ).$id;

			console.debug( "Saving account: ", account );

			try {
				let result = await this.updateAccount( { nodeId : this.nodeId, accountId : id, updates : account } );
				if( !id || null === result )
					throw new Error( "This account is no longer found in the repository!" );
				
				// TODO: close loading overlay

			} catch( err ) {

				// TODO: Switch loading overlay to ERROR overlay.

				console.warn( "Account save failed:", err );

				// TODO: Set this action, as the result of dismissing the ERROR OVERLAY
				this.$router.push( { name : 'accounts', params : { nodeId : this.nodeId } } );
			}
		},
		...mapActions({
			readAccount: "accounts/read",
			updateAccount: "accounts/update",
			deleteAccount: "accounts/delete",
		}),
	},
	async mounted( )
	{
		try {
			this.editor = ace.edit( "editor", {
				mode: "ace/mode/json",
				theme: "ace/theme/tomorrow",	//"ace/theme/dracula",
				maxLines: 20,
				minLines: 5,
				fontSize: 14,
				showPrintMargin : false
			});
			this.accountSettings = this.getAccount( ) || { roles : { } };
			await this.refreshAccount( );
		} catch( err ) { throw err; }
	}
};
</script>

<style scoped>
div#editor
{
	border: 1px solid #666;
}
h2 {
	font-weight: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/Account.vue